import React from 'react';

import Urls from '../../../config/index';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { message, Table, Tabs, Popconfirm, Button, Modal, Form, Pagination, Row, Col } from 'antd';
const FormItem = Form.Item;
import request from '../../utils/request';
import { paramsEncode } from '../../utils/index';
import greenImg from '../../circleGreen.png';
import redImg from '../../circleRed.png';

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            server: [],
            worker: [],
        };
    }
    componentWillMount() {
        this.getList(Urls.MonitorUrl.service);
    }

    async getList(url) {
        try {
            let response = await request(url);
            this.setState(Object.assign(this.state, { server: response.Server }, { worker: response.Workers }));
        } catch (e) {
            alert(e.message);
        }
    }

    render() {
        const serverColumns = [
            {
                title: '总并发',
                dataIndex: 'taskParallel',
                key: 'taskParallel',
            },
            {
                title: '阻塞任务数',
                dataIndex: 'blockingTaskNumber',
                key: 'blockingTaskNumber',
            },
            {
                title: '丢弃任务数',
                dataIndex: 'discardTaskNumber',
                key: 'discardTaskNumber',
            },
            {
                title: '客户端数',
                dataIndex: 'workerNumber',
                key: 'workerNumber',
            },
            {
                title: '上次更新时间',
                dataIndex: 'updateTime',
                key: 'updateTime',
                render: (text, record, index) => {
                    return moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '机器IP',
                dataIndex: 'hostIp',
                key: 'hostIp',
            },
            {
                title: '端口号',
                dataIndex: 'port',
                key: 'port',
            },
            {
                title: '服务状态',
                dataIndex: 'status',
                key: 'status',
                render: (text, record, index) => {
                    return text ? <img  src={greenImg} /> : <img  src={redImg} />;
                },
            },
            {
                title: '启动时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text, record, index) => {
                    return moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '任务描述',
                dataIndex: 'taskParallelDesc',
                key: 'taskParallelDesc',
            },
        ];

        const workerColumns = [
            // {
            //     title: 'ID',
            //     dataIndex: 'workerId',
            //     key: 'workerId',
            // },
            {
                title: '并发数',
                dataIndex: 'taskParallel',
                key: 'taskParallel',
            },
            {
                title: '阻塞任务数',
                dataIndex: 'threadPoolSize',
                key: 'threadPoolSize',
            },
             {
                title: '累计处理任务数',
                dataIndex: 'processTaskNum',
                key: 'processTaskNum',
            },
            {
                title: '上次更新时间',
                dataIndex: 'lastUpdateTime',
                key: 'lastUpdateTime',
                render: (text, record, index) => {
                    return moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '机器IP',
                dataIndex: 'localIp',
                key: 'localIp',
            },
            {
                title: '端口号',
                dataIndex: 'port',
                key: 'port',
            },
            {
                title: '启动时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text, record, index) => {
                    return moment(text).format('YYYY-MM-DD HH:mm:ss');
                },
            },
            {
                title: '服务状态',
                dataIndex: 'status',
                key: 'status',
                render: (text, record, index) => {
                    return text ? <img  src={greenImg} /> : <img  src={redImg} />;
                },
            },
        ];
        return (
            <div>
                <h2>服务监控</h2>
                <Row className="wrapperBox" style={{ marginTop: '30px' }}>
                    <h2>Server</h2>
                    <Table columns={serverColumns} dataSource={this.state.server} pagination={false} bordered />
                </Row>
                <Row className="wrapperBox" style={{ marginTop: '20px' }}>
                    <h2>Worker</h2>
                    <Table columns={workerColumns} dataSource={this.state.worker} pagination={false} bordered />
                </Row>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/sider/servermonitor.js